import React from 'react';
import { TITLE_OPTIONS } from '../../constants/formOptions';

/**
 * Reusable TitleSelect component for native select elements
 * Use this for class components that don't use Formik
 *
 * For Formik-based forms, use the Select component with options={TITLE_OPTIONS}
 */
export default function TitleSelect({
  value,
  onChange,
  onBlur,
  name = "title",
  className = "form-control",
  style = {},
  defaultLabel = "-- Select title --",
  required = false
}) {
  return (
    <select
      name={name}
      className={className}
      style={style}
      onChange={onChange}
      onBlur={onBlur}
      value={value || ""}
      required={required}
      aria-label="Select title"
    >
      <option value="" disabled>
        {defaultLabel}
      </option>
      {TITLE_OPTIONS.map((title) => (
        <option key={title} value={title}>
          {title}
        </option>
      ))}
    </select>
  );
}

// Export TITLE_OPTIONS for use in other components
export { TITLE_OPTIONS };
